module.exports = __webpack_public_path__ + "static/media/DSC_7025.00fd12a8.jpg";